import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { Store } from '@ngxs/store'
import { NgxUiLoaderService } from "ngx-ui-loader"
import { Subscription, throwError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import {

  ToastService,
  AccountService,
  ValidationService,
  AuthenticationService
} from '../../../core/services';

import { PasswordValidator } from '../../../shared/validators';
import { StaticDataActions } from '../../../state';
import { ApplicationRole, UserProfile } from '../../../core/models';
import { ConfirmComponent } from '../../../shared/components';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'gs-security',
    templateUrl: './security.component.html',
    standalone: false
})
export class SecurityComponent implements OnInit, OnDestroy {
  readonly ApplicationRole = ApplicationRole;

  user: UserProfile;
  totalTransaction: number = 0;

  form: FormGroup = this.formBuilder.group({
    oldPassword: [null, [Validators.required]],
    password: [null, [Validators.required, PasswordValidator.strong]],
    confirmPassword: [null, [Validators.required, PasswordValidator.matchPassword]]
  });

  formDeleteAccount: FormGroup = this.formBuilder.group({
    // hasConfirmed: [false, [Validators.requiredTrue]],
  });

  private subscriptions: Subscription[] = [];

  constructor(
    private toastService: ToastService,
    private router: Router,
    private modalService: NgbModal,
    private ngxUiLoaderService: NgxUiLoaderService,
    private authService: AuthenticationService,
    private accountService: AccountService,
    private formBuilder: FormBuilder,
    private store: Store,
    public vs: ValidationService
  ) { }

  ngOnInit() {
    this.store.dispatch([
      new StaticDataActions.GetHobbies()
    ]);

    this.subscriptions.push(
      this.store.select<UserProfile>(state => state.auth.user)
        .subscribe(user => {
          this.user = user;
        }),
    );

    this.getTotalTransactions();
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  getTotalTransactions() {
    this.subscriptions.push(
      this.accountService.getTotalTransactions()
        .subscribe((response: any) => {
          this.totalTransaction = response;
        })
    );
  }

  onSubmit() {
    if (!this.form.valid) {
      this.vs.triggerValidation(this.form);
      return;
    }

    const model = {
      ...this.form.value
    };

    this.ngxUiLoaderService.start();
    this.subscriptions.push(
      this.accountService.changePassword(model)
        .pipe(
          catchError(e => {
            this.toastService.show('Eroare', e.error?.detail || e.error?.title || 'A aparut o problema neasteptata. Echipa noastra lucreaza pentru a o remedia.', 'error');
            return throwError(e);
          }),
          finalize(() => {
            this.ngxUiLoaderService.stop();
          })
        )
        .subscribe(() => {
          this.form.reset();
          this.toastService.show('Succes', 'Parola a fost schimbata cu succes.', 'success');
          this.router.navigate(['/auth/autentificare']);
        })
    );
  }

  onDeleteAccountSubmit() {
    const modalRef = this.modalService.open(ConfirmComponent);
    modalRef.componentInstance.title = (this.totalTransaction == 0) ? 'Confirma stergerea' : 'Confirma dezactivarea';
    modalRef.componentInstance.description = (this.totalTransaction == 0) ?
      'Toate datele asociate contului vor fi sterse si nu pot fi recuperate.'
      : 'Contul tau contine tranzactii si nu poate fi sters, dar poate fi dezactivat.';
    modalRef.componentInstance.acceptLabel = (this.totalTransaction == 0) ? 'Sterge' : 'Dezactiveaza';
    modalRef.componentInstance.acceptClass = 'btn-danger';
    modalRef.componentInstance.rejectLabel = 'Anuleaza';

    this.subscriptions.push(
      modalRef.componentInstance.done.subscribe(result => {
        if (result === 'accept') {
          if (this.totalTransaction == 0) {
            this.ngxUiLoaderService.start();
            this.subscriptions.push(
              this.accountService.deleteUser(this.user.code)
                .pipe(
                  catchError(e => {
                    this.toastService.show('Eroare', e.error?.detail || e.error?.title || 'A aparut o problema neasteptata. Echipa noastra lucreaza pentru a o remedia.', 'error');
                    return throwError(e);
                  }),
                  finalize(() => {
                    this.ngxUiLoaderService.stop();
                  })
                )
                .subscribe(() => {
                  this.toastService.show(
                    'Success',
                    'Contul a fost sters cu succes."',
                    'success'
                  );
                  this.authService.logout();
                })
            );
          }
          else {
            this.ngxUiLoaderService.start();
            this.subscriptions.push(
              this.accountService.lockUser(this.user.code)
                .pipe(
                  catchError(e => {
                    this.toastService.show('Eroare', e.error?.detail || e.error?.title || 'A aparut o problema neasteptata. Echipa noastra lucreaza pentru a o remedia.', 'error');
                    return throwError(e);
                  }),
                  finalize(() => {
                    this.ngxUiLoaderService.stop();
                  })
                )
                .subscribe(() => {
                  this.toastService.show(
                    'Success',
                    'Contul a fost dezactivat cu succes.',
                    'success'
                  );
                  this.authService.logout();
                })
            );
          }
        }
      })
    );

  }
}
